module.exports = __webpack_public_path__ + "static/media/no_users.6463d385.svg";